module.exports = __webpack_public_path__ + "static/img/leftShopOn.8b151855.png";